import styles from './styles/Subs.wrapper.module.scss';
import React from 'react';
import { SubTabsSkeleton } from './SubTabs.skeleton';
import { SubItemsSkeleton } from './SubItems.skeleton';
export const SubsWrapperSkeleton = ({ showTabs }) => {
    return (React.createElement("div", { className: `pev:none ${styles.wrapper}` }, showTabs
        ? React.createElement(SubTabsSkeleton, null)
        : React.createElement(SubItemsSkeleton, null)));
};
